import React from 'react'
import 'project/polyfill'
import { NextPageWithLayout } from '../types/nextPageWithLayout'
import SeoContainer, {
  SeoContainerProps,
} from 'components/util/containers/SeoContainer'
import { ItemListElements } from 'next-seo/lib/types'
import Strings from 'project/localisation'
import { homeBreadcrumb } from 'components/util/containers/Breadcrumbs'
import { I18NConfig } from 'next/dist/server/config-shared'
import { createClient } from '../prismicio'
import { Utils } from 'common/utils'
import { getPosts } from 'common/cms-sdk'
import { Query } from '@prismicio/types'
import { TBlogPostResult } from 'common/cms-types'
import PoweredByHero from 'components/hero/PoweredByHero'
import Card from 'components/cards/base/Card'
import { marketplaceStrings } from 'common/strings/marketplace-strings'
import BecomeAPartnerForm from 'components/sections/BecomeAPartnerForm'
import imageResize from 'project/image-proxy-web'

export type MarketplacePartnerPageType = {
  posts: Query<TBlogPostResult>
}
const MarketplacePartnerPage: NextPageWithLayout<
  MarketplacePartnerPageType
> = ({ posts }) => {
  const seoProps: SeoContainerProps['seoProps'] = {
    description: marketplaceStrings.seoBecomeAPartnerDescription,
    openGraph: {
      url: 'https://www.hoxtonmix.com/marketplace-partner/',
    },
    title: marketplaceStrings.seoBecomeAPartnerTitle,
  }

  const membershipBreadcrumb: ItemListElements[] = [
    homeBreadcrumb()[0],
    {
      item: 'https://www.hoxtonmix.com/marketplace-partner/',
      name: `${marketplaceStrings.becomeAPartner}`,
      position: 2,
    },
  ]

  return (
    <SeoContainer
      noIndex
      noFollow={false}
      breadcrumb={membershipBreadcrumb}
      seoProps={seoProps}
    >
      <main>
        <PoweredByHero
          className={'h-auto d-flex justify-content-center align-items-end'}
          background={'purple3'}
        >
          <div className=' text-center pt-14 align-items-center flex-column'>
            <div className={'d-flex flex-lg-column flex-column-reverse'}>
              <img
                fetchPriority='high'
                loading='eager'
                className='img-fluid hero__image hero__image--mailroom mt-xxxl-n4 mt-lg-0 mt-n3'
                alt={`${Strings.mailroom} ${Strings.logo}`}
                src={imageResize(
                  require('public/images/plans/internation-page-plugz-head-desktop.png'),
                )}
              />
            </div>
          </div>
        </PoweredByHero>
        <div className='container position-relative become-a-partner-form'>
          <div className='row'>
            <div className='col-12 col-xl-8 offset-xl-2'>
              <h2 className='text-center text-white'>
                {marketplaceStrings.becomeAPartner}
              </h2>
              <p className='text-center text-white d-none d-xl-block'>
                {marketplaceStrings.becomeAPartnerDetail}
              </p>
              <Card
                radius='lg'
                padding='lg'
                className='h-auto'
                shadow
                theme='white'
              >
                <BecomeAPartnerForm />
              </Card>
            </div>
          </div>
        </div>
        <div />
      </main>
    </SeoContainer>
  )
}
const PAGE_SIZE = 4

export async function getStaticProps(
  context: I18NConfig & { locale?: string; params: { uid: string } },
) {
  try {
    const client = createClient(context)
    const lang = Utils.getLocaleID(context.locale || context.defaultLocale)
    const posts = await getPosts(client, 1, lang, PAGE_SIZE, undefined)

    return {
      props: {
        posts,
      },
    }
  } catch (e) {
    console.log(e)
    return {
      props: {},
    }
  }
}
export default MarketplacePartnerPage
